<template>
  <div>
    <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
      <b-card
        class="card text-center"
        style="background-color: #f5f6fa; box-shadow: none"
        border-variant="primary"
        header="REASON FOR DECLINE"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">REASON FOR DECLINE</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i
                  style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  "
                  class="tim-icons icon-simple-remove"
                  @click="modals.disputereason = false"
                ></i>
              </base-button>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="col-lg-12">
            <textarea
              style="border: 1px solid #aaa"
              type="textarea"
              placeholder="Reason for declining..."
              v-model="reason"
              :class="{ textarea: true }"
            ></textarea>
          </div>
        </div>

        <p
          style="
            color: #707070;
            opacity: 0.7;
            text-align: left;
            font-size: 14px;
          "
        >
          Dispute document
        </p>

        <div class="col-lg-12">
          <div v-if="alldeclinedocs.length === 0">
            <p
              style="
                color: #707070;
                opacity: 0.7;
                text-align: left;
                font-size: 14px;
              "
            >
              No file chosen
            </p>
          </div>
          <div v-for="(item, index) in alldeclinedocs" :key="index">
            <div class="row">
              <div class="col-lg-1 text-center">
                <p style="color: #A5A5A5; font-size: 14px">{{ index + 1 }}.</p>
              </div>
              <div class="col-lg-9 text-left">
                <p style="color: #A5A5A5; font-size: 14px">{{ item.filename }}</p>
              </div>
              <div class="col-lg-1 text-center">
                <a :href="item.fileurl" :download="item.filename">
                  <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                </a>
              </div>
              <div class="col-lg-1 text-center">
                <i
                  class="tim-icons icon-simple-remove remove-icon"
                  @click="removeDeclineDocs(item.fileid)"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-2">
            <div class="fileinput">
              <label
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
                for="file-upload"
                type="primary"
                class="btn"
              >
                Upload
              </label>

              <div
                class="d-flex justify-content-center spinner"
                v-if="this.uploadload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="file-upload"
                ref="disputedoc"
                type="file"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="onFileChangeDeclineDocs"
              />
            </div>
          </div>

          <div class="col-lg"></div>

          <div class="col-lg-4 text-right">
            <base-button
              type="primary"
              :disabled="candecline"
              v-on:click="decline()"
              >Submit</base-button
            >
          </div>
        </div>
      </b-card>
    </modal>

    <StatusModal
      :show.sync="modals.successModal"
      :message="modal.success"
      :title="modal.successTitle"
    />
    <StatusModal
      :show.sync="modals.removeModal"
      :message="modal.remove"
      :title="modal.removeTitle"
    />
    <StatusModal
      :show.sync="modals.removeFailedModal"
      :message="modal.removeFailed"
      :title="modal.removeTitle"
    />

    <div class="row">
      <div class="col-lg-4 d-flex">
        <card class="card-eprf">
          <p style="color: #358CCB; font-size: 24px; font-weight: 300">
            JOB INFORMATION
          </p>
          <div style="height: 520px; overflow: auto; overflow-x: hidden">
            <p class="new-title">Job Reference No.</p>
            <p class="subtitle">{{ refno }}</p>

            <p class="new-title">Service Location</p>
            <p class="subtitle">
              {{ servicelocation }}
            </p>

            <p class="new-title">PIC Full Name</p>
            <p class="subtitle">
              {{ picfullname }}
            </p>

            <p class="new-title">PIC Phone No.</p>
            <p class="subtitle">
              {{ picphoneno }}
            </p>

            <p class="new-title">PIC Fax No.</p>
            <p class="subtitle">
              {{ picfaxno }}
            </p>

            <p class="new-title">PIC Email</p>
            <p class="subtitle">
              {{ picemail }}
            </p>
          </div>
        </card>
      </div>
      <div class="col-lg-8 d-flex">
        <card class="card-eprf">
          <div class="row" style="display: flex">
            <div class="col-lg">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                WASTE DETAILS
              </p>
            </div>
          </div>

          <div
            style="
              height: 100px;
              padding: 20px 20px 0px 20px;
              margin: 30px 30px 0px 0px;
            "
            class="d-flex justify-content-center spinner"
            v-if="load == true"
          >
            <circle-8></circle-8>
          </div>

          <div
            id="tableku"
            v-if="load == false"
            style="height: 500px; overflow: auto; overflow-x: hidden"
          >
            <div class="row">
              <div class="col-lg">
                <el-table
                  :data="tableDatas"
                  :row-style="tableRowClassName"
                  :header-cell-style="{
                    background: '#358DCC',
                    border: 'transparent',
                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#FFFFFF',
                  }"
                >
                  <el-table-column label="NO." width="50" align="center">
                    <div slot-scope="scope">
                      <p style="color: #707070">
                        {{ scope.$index + 1 }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="wastetype"
                    label="WASTE TYPE"
                  >
                    <div slot-scope="{ row }">
                      <div align="left">
                        <p class="swcode-text" style="color: #707070">
                          SW Code: {{ row.swcodename }}
                        </p>
                        <p
                          v-if="row.wastetype != 'Tyre'"
                          style="color: #707070"
                        >
                          Packaging: {{ row.packagingqty }}
                          {{ row.packagingtype }}
                        </p>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="150"
                    align="center"
                    prop="wasteComponents"
                    label="WASTE COMPONENT"
                  >
                    <template slot-scope="{ row }">
                      <div
                        v-for="(component, index) in row.wasteComponents"
                        :key="index"
                      >
                        <p style="text-align: left; color: #707070">
                          {{ index + 1 }}. {{ component.name }}
                        </p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :min-width="150"
                    align="center"
                    prop="estqty"
                    label="QUANTITY"
                  >
                    <div slot-scope="{ row }">
                      <p style="color: #707070">
                        {{ row.estqty }} {{ row.estqtyunit }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="120"
                    align="center"
                    prop="remarks"
                    label="REMARKS"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg"></div>
      <div class="col-lg-4 text-right">
        <base-button type="danger" @click="prevTab()" class="spaced-button"
          >Back</base-button
        >

        <base-button
          v-if="status == 1 && statusname != 'Rejected'"
          type="cancel"
          @click="modals.disputereason = true"
          class="spaced-button"
        >
          Decline
        </base-button>

        <!-- silap, kalau "status" > current view page, view;  -->
        <!-- status <= current view page, edit -->

        <base-button
          v-if="status == 1 && statusname != 'Rejected'"
          type="primary"
          @click="accept()"
          class="spaced-button"
          >Accept</base-button
        >
        <base-button
          v-if="status >= 2"
          type="primary"
          @click="nextTab()"
          class="spaced-button"
          >Next</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    Modal,
    BCard,
  },

  data() {
    return {
      refno: "",
      servicelocation: "",
      picfullname: "",
      picphoneno: "",
      picfaxno: "",
      picemail: "",
      status: 0,
      statusname: "",
      displayflag: false,

      alldeclinedocs: [],
      reason: "",

      uploadload: false,
      modal: modal,

      load: false,

      tableDatas: [
        {
          wastetypename: "WASTE HERE",
        },
      ],

      modals: {
        disputereason: false,
        removeModal: false,
        removeFailedModal: false,
        submit: false,
        successModal: false,
      },
    };
  },
  created() {
    this.getData();

    if (this.$route.params.action == "edit") {
      this.displayflag = true;
    }
  },
  mounted() {},
  computed: {
    candecline() {
      return this.reason === "";
    },
  },
  watch: {
    status() {
      if (this.status == 100) {
        this.displayflag = false;
      } else if (this.status != 100) {
        this.displayflag = false;
      }
    },
  },
  methods: {
    decline() {
      if (this.reason != "") {
        let obj = {
          remark: this.reason,
        };

        this.$http
          .post(
            ":10001/api/v1/outgoing/waste/" +
              this.$route.params.outgoingid +
              "/reject",
            obj
          )
          .then((res) => {
            if (!res.error) {
              swal({
                title: `Success!`,
                text: "Declining job success.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              }).then((result) => {
                console.log(result);
                if (result.value) {
                  this.modals.disputereason = false;
                  setTimeout(() => {
                    this.redirect();
                  }, 1000);
                  this.reason = "";
                }
              });
            } else {
              console.log("decline not success", response);
            }
          })
          .catch((err) => {
            swal({
              title: `Error!`,
              text: "Declining job failed.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-cancel btn-fill",
              type: "error",
            });
          });
      } else {
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },
    accept() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.outgoingid +
            "/accept"
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Accepting job success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                setTimeout(() => {
                  this.getData();
                }, 1000);
                this.nextTab();
              }
            });
          } else {
            console.log("job not complete", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Accepting job failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },
    onFileChangeDeclineDocs(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/decline-document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("why");
                setTimeout(() => {
                  this.getData();
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";
          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.uploadload = false;
            this.buttondisabled = false;
          });
      } else {
        this.quotitle = "";
      }
    },
    removeDeclineDocs(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/decline-document/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },
    redirect() {
      this.$router.push("/Vendor/Job");
    },
    getData() {
      this.load = true;
      this.tableDatas = [];
      this.alldeclinedocs = [];

      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.outgoingid)
        .then((res) => {
          if (!res.error) {
            this.load = false;
            let response = res.message;

            console.log(response);

            this.refno = response.reference_number;
            this.servicelocation = response.service_location.location;
            this.picfullname = response.assign_to_afes.user_name;
            this.picphoneno =
              response.assign_to_afes.phone_number == null ||
              response.assign_to_afes.phone_number == ""
                ? "-"
                : response.assign_to_afes.phone_number;
            this.picfaxno =
              response.assign_to_afes.fax_number == null ||
              response.assign_to_afes.fax_number == ""
                ? "-"
                : response.assign_to_afes.fax_number;
            this.picemail =
              response.assign_to_afes.email == null ||
              response.assign_to_afes.email == ""
                ? "-"
                : response.assign_to_afes.email;
            this.status = response.status.status;
            this.statusname = response.status.name;
            if (this.$route.params.action == "view") {
              let parameter = {
                step: "0",
                direction: "depan",
                data: [],
              };
              this.$emit("my-event", parameter);
            }

            if (this.$route.params.action == "edit" && this.status == 2) {
              this.nextTab();
            }

            if (this.$route.params.action == "edit" && this.status == 3) {
              this.nextTab();
            }

            if (response.decline_document != null)
              for (var i = 0; i < response.decline_document.length; i++) {
                let obj = {
                  filename: response.decline_document[i].meta.filename,
                  fileurl: response.decline_document[i].url,
                  fileid: response.decline_document[i].document_id,
                };
                this.alldeclinedocs.push(obj);
              }

            let component = [];
            let comp = "";
            if (response.waste_detail != null) {
              for (var i = 0; i < response.waste_detail.length; i++) {
                component = [];
                comp = "";
                console.log(response.waste_detail[i].waste_component);
                if (response.waste_detail[i].waste_component != null) {
                  for (
                    var j = 0;
                    j < response.waste_detail[i].waste_component.length;
                    j++
                  ) {
                    let oo = {
                      name: response.waste_detail[i].waste_component[j],
                    };
                    component.push(oo);
                  }
                }

                let obj = {
                  swcodename: response.waste_detail[i].waste_type.name,
                  packagingqty: response.waste_detail[i].packaging_quantity,
                  packagingtype: response.waste_detail[i].packaging.name,
                  wastetype: "",
                  wasteComponents: component,
                  estqty: response.waste_detail[i].quantity,
                  estqtyunit: response.waste_detail[i].quantity_unit,
                  remarks:
                    response.waste_detail[i].remark == null ||
                    response.waste_detail[i].remark == ""
                      ? "None"
                      : response.waste_detail[i].remark,
                };
                this.tableDatas.push(obj);
              }

              console.log(this.tableDatas);
            }
          }
        });
    },
    prevTab() {
      let parameter = {
        step: "1",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      console.log("sini keee");
      let parameter = {
        step: "1",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
  },
};
</script>

<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.custom-dropdown-2 {
  width: 300px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.custom-table .el-table__body-wrapper {
  overflow-y: scroll;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #358dcc;
  border-radius: 6px;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.custom-input {
  padding: 5px 5px 5px 5px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

.spaced-button {
  margin: 0 5px;
}
</style>
